import styled from 'styled-components'
import variables from '../../styles/variables'

export const Divider = styled.div`
  @media ${variables.media.lg} {
    border-top: 1px solid #eee;
    margin: 80px 0 50px 0;
  }
`
